import StepBar2 from "../atoms/layout/StepBar2";
import SurveyContainer from "../atoms/layout/SurveyContainer";
import SurveyTitle from "../atoms/typography/Typography";
import Header from "../modules/layout/Header";
import InfoInsertForm from "../modules/application/InfoInsertInform";

const InfoInsert = ({ visibility, register }) => {
  //정보 입력 페이지 에러 분기
  const userFirstInfoError = {
    name: "이름을 입력 해 주세요.",
    tel: "휴대폰 번호를 입력 해 주세요.",
    email: "이메일을 입력 해 주세요.",
    year: "생년월일을 선택 해 주세요.",
    month: "생년월일을 선택 해 주세요.",
    date: "생년월일을 선택 해 주세요.",
    organizationFirst: "소속기관을 입력 해 주세요.",
    organizationLast: "소속기관을 입력 해 주세요.",
    rating: "등급을 선택 해 주세요.",
    age: "연령을 선택 해 주세요.",
    residentialArea: "거주지역을 선택 해 주세요.",
    overseasExperience: "해외 경험을 선택 해 주세요.",
    // bankAccountNumber: "계좌번호를 입력 해 주세요.",
    // accountHolder: "예금주를 입력 해 주세요.",
    // bankName: "은행을 선택 해 주세요.",
    // file: "통장사본 이미지를 첨부 해 주세요.",
  };

  //정보 입력 페이지(1)에서 다음 눌렀을 때
  const onSubmit = (data) => {
    console.log(data);
    // if ((data.bankAccountNumber || data.accountHolder || data.bankName) && data.file.length === 0) {
    //   console.log(data.file);
    //   alert("통장사본 이미지를 첨부 해 주세요.");
    //   return false;
    // }

    //다음 페이지로 이동 후 정보 저장

    // if (
    //   data.bankAccountNumber ||
    //   data.accountHolder ||
    //   data.bankName ||
    //   data.file.length !== 0
    // ) {
    //   if (data.bankAccountNumber) {
    //     alert("계좌번호를 입력해 주세요");
    //     return false;
    //   }

    //   if (data.accountHolder) {
    //     alert("예금주를 입력해 주세요");
    //     return false;
    //   }

    //   if (data.bankName) {
    //     alert("은행명을 골라주세요");
    //     return false;
    //   }

    //   if (data.file.length === 0) {
    //     alert("통장사본을 첨부해주세요");
    //     return false;
    //   }
    // }

    // for (const [key, value] of Object.entries(userFirstInfoError)) {
    //   if (!data[key]) {
    //     console.log(key);
    //     alert(value);
    //     return false;
    //   }
    // }
  };

  return (
    <div style={{ display: visibility }}>
      <Header />
      <SurveyContainer title="영어 말하기 평가">
        <SurveyTitle className="page-title text-align-center">
          정보 입력
        </SurveyTitle>
        <StepBar2 step={0} />
        <InfoInsertForm register={register} />
      </SurveyContainer>
    </div>
  );
};

export default InfoInsert;
